import type { SVGProps } from "react";
export function Exclamation(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m6.36642 3.08329c.70563-1.22222 2.46976-1.22222 3.17543 0l4.61885 8.00001c.7056 1.2222-.1764 2.75-1.5878 2.75h-9.23756c-1.41131 0-2.29337-1.5278-1.58772-2.75zm2.30943.5c-.3208-.55555-1.12267-.55555-1.4434 0l-4.61881 8.00001c-.32074.5555.0802 1.25.7217 1.25h9.23756c.6416 0 1.0425-.6945.7218-1.25zm-.72173 2.58333c.27613 0 .5.22386.5.5v1.33334c0 .27613-.22387.5-.5.5-.27614 0-.5-.22387-.5-.5v-1.33334c0-.27614.22386-.5.5-.5zm-.5 4.49998c0-.2761.22386-.5.5-.5h.00666c.27614 0 .5.2239.5.5 0 .2762-.22386.5-.5.5h-.00666c-.27614 0-.5-.2238-.5-.5z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
